function Titlebar(props) {
    return (
        <div className="titlebar">{props.content}</div>
    );
}

export default Titlebar;